// @ts-nocheck
// Store Custom Component
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { StatusColor, statusStyles } from "@store/Themes/common/mixins/status";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import styled, { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel | ProductModel;
    extendedStyles?: ProductDiscontinuedStyles;
    overridedStyles?: ProductDiscontinuedStyles;
}

type Props = OwnProps;

export interface ProductDiscontinuedStyles {
    wrapper?: InjectableCss;
    discontinuedMessage?: InjectableCss;
    productDiscutinuedText?: TypographyProps;
}

export const productDescriptionStyles: ProductDiscontinuedStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-flow: row wrap;
            margin-bottom: ${pxToRem(15)};
        `,
    },
    productDiscutinuedText: {
        css: css`
            width: 100%;
            ${breakpointValues(pxToRemArray([10, 14, null, null, null]), "font-size")}
            line-height: 1;
            ${wrapInContainerStyles}
        `,
    },
};

const DiscontinuedMessage = styled.div<{ _color: StatusColor }>`
    ${x => statusStyles(x._color)}
`;

const ProductDiscontinued = ({ product, extendedStyles, overridedStyles }: Props) => {
    const styles = useExpandProps(productDescriptionStyles, extendedStyles, overridedStyles);

    const productIsDiscontinued =
        ("product" in product && product.product.isDiscontinued) ||
        ("isDiscontinued" in product && product.isDiscontinued) ||
        ("product" in product && product.product.properties.rslDiscontinued === "true") ||
        ("properties" in product && product.properties.rslDiscontinued === "true");

    if (!productIsDiscontinued) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <DiscontinuedMessage _color="neutral" {...styles.discontinuedMessage}>
                <Typography {...styles.productDiscutinuedText}>{translate("Discontinued Model")}</Typography>
            </DiscontinuedMessage>
        </StyledWrapper>
    );
};

export default ProductDiscontinued;
